export default function () {
  return {
    admins: []
  };
}